module.exports = __webpack_public_path__ + "static/media/1_upload.c36461e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/product/1_upload.jpg
// module id = 306
// module chunks = 0